<template>
  <div class="top-menu">
    <div class="left">
      <a-icon class="icon" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="changeCollapsed" />
    </div>

    <div class="brand" v-show="showLogo">
      <span>{{ brandName }}</span>
    </div>

    <div class="right">
      <a-dropdown :trigger="['click']">
        <div class="user">
          <a-icon type="user" class="user-icon" />
          <span>{{ name }}</span>
          <a-icon type="down" class="arrow-icon" />
        </div>
        <a-menu slot="overlay" class="user-menu">
          <a-menu-item key="logout" @click="logout">
            <a-icon type="logout" />
            退出登录
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'TopMenu',
  model: {
    prop: 'collapsed'
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      userName: '',
      showLogo: true,
      brandName: process.env.VUE_APP_BRAND_NAME || '',
    }
  },

  created() {
    this.userName = localStorage.getItem('userName')
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    }),
    ...mapState({ name: state => state.user.name }),
    bread(){
      let breadList = []
     breadList = this.$route.matched.map(item => {
          return {
            path: item.path,
            name: item.meta.name
          }
        })
      return breadList
    }
  },

  methods: {
    changeCollapsed() {
      this.$emit('input', !this.collapsed)
      this.$bus.$emit('showLogo')
    },

    refresh() {
      history.go(0)
    },

    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push('/login')
        // this.$store.dispatch('tagsView/delAllViews')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
  background: #ffffff;
  color: #303133;
  padding: 0 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid #e4e7ed;
  position: relative;
  z-index: 1000;

  .icon {
    font-size: 18px;
    transition: all 0.25s ease;
  }

  .left {
    display: flex;
    align-items: center;

    .icon {
      margin-right: 0;
      padding: 10px;
      border-radius: 6px;
      cursor: pointer;
      color: #606266;
      transition: all 0.25s ease;
      
      &:hover {
        background: #f5f7fa;
        color: $brand-primary;
      }
      
      &:active {
        background: #ebedf0;
      }
    }
  }

  // 品牌名绝对定位居中，不受左右两侧宽度影响
  .brand {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 2px;
    white-space: nowrap;
    pointer-events: none;
    
    span {
      // 深→主→浅三段渐变，比原主色→浅色对比更强、在白底上更醒目
      background: linear-gradient(135deg, $brand-primary-dark 0%, $brand-primary 50%, $brand-primary-light 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      // drop-shadow 作用于渐变文字的渲染结果，增加立体感（text-shadow 会被透明填充吞掉）
      filter: drop-shadow(0 2px 4px rgba($brand-primary, 0.25));
    }
  }

  .right {
    display: flex;
    align-items: center;

    .user {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      padding: 8px 14px;
      border-radius: 6px;
      color: #606266;
      font-size: 14px;
      font-weight: 500;
      background: #f5f7fa;
      transition: all 0.25s ease;
      
      &:hover {
        background: #ebedf0;
        color: $brand-primary;
        
        .user-icon {
          color: $brand-primary;
        }
      }
      
      .user-icon {
        font-size: 16px;
        color: #909399;
        transition: all 0.25s ease;
      }
      
      .arrow-icon {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .top-menu {
    padding: 0 16px;
    height: 60px;
    
    .brand {
      font-size: 19px;
      letter-spacing: 1px;
    }
    
    .right {
      .user {
        padding: 6px 10px;
      }
    }
  }
}
</style>
